import React from "react";

/* One thrown error used to unmount the whole app and paint a blank white page. Anything wrapped in
   here keeps the rest of the app alive and shows a card the person can act on instead. */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Caught by ErrorBoundary:", error, info?.componentStack);
    this.props.onError?.(error);
  }

  reset = () => this.setState({ error: null });

  render() {
    if (!this.state.error) return this.props.children;
    if (this.props.fallback) return this.props.fallback(this.reset, this.state.error);
    return (
      <div data-testid="error-boundary-fallback"
           className="min-h-screen flex items-center justify-center bg-royal-deep px-6 text-center">
        <div>
          <p className="font-display text-xl font-semibold text-white">Something went wrong</p>
          <p className="mt-3 max-w-md text-sm text-blue-100/70">
            Nothing was lost. Reload and you will be right back where you were.
          </p>
          <button data-testid="error-boundary-reload" onClick={() => window.location.reload()}
            className="mt-6 h-11 rounded-full bg-gold px-7 font-display text-xs font-bold uppercase
                       tracking-[0.16em] text-royal-deep">
            Reload
          </button>
        </div>
      </div>
    );
  }
}
